import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TimeService } from 'src/app/services/time/time.service';

@Component({
  selector: 'app-format-management',
  templateUrl: './format-management.component.html',
  styleUrls: ['./format-management.component.css']
})
export class FormatManagementComponent implements OnInit {

  lambdaError: boolean = false;
  lambdaMessage: string = "";
  bluePrint = {"Key": "", "data": {"matchPattern": "", "formatPattern": ""}, "collectionName": "formatting"}
  //list of formatting objects
  formatList: Array<any> = [];
  formatKey: string = "";
  inputString: string = "";
  outputString: string = "";
  editRow: boolean = false;
  formValid = true;
  currentUser: string;

  constructor(private telecomService: TelecomService, private auth: AuthService) { }

  ngOnInit() {
    this.currentUser = this.auth.currentUser
    this.getRegexPairs();
  }


  getRegexPairs(){
    this.telecomService.getRows(environment.formatManagementLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        this.formatList = response.body.items;
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.body.message;
        console.error(response);
      }
    });
  }


  addRegexPair(row: any){
    row['item']['data']['updatedBy'] = this.auth.currentUser;
    this.telecomService.saveRow(row, environment.formatManagementLambdaName).then((response: any) => {
      if(response.statusCode == 200){
        let item = response.body.item;
        let temp = JSON.parse(JSON.stringify(this.formatList));
        for(let x = 0; x < temp.length; x++){
          if(temp[x].Key == item.Key){
            temp[x] = item;
            this.formatList = temp;
            break;
          }
        }
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.body.message;
      }
    });
  }


  //execute a formatting test
  callFormattingLambda(){
    this.outputString = '';
    let params = {
      FunctionName: environment.formatConnectStringLambdaName,
      Payload: JSON.stringify({
        Details: {
          Parameters: {
              regexInput: this.inputString,
              key: this.formatKey,
              noCache: true
            }
          }
      })
    };
    console.log(params);
    this.telecomService.callLambda(params, 'Failed to perform operation').then((response: any) => {
      if(response.status == 200){
        this.outputString = response.output;
      }else{
        this.lambdaError = true;
        this.lambdaMessage = response.message;
      }
    });
  }


  //sets local bool to true if the user is making a new row,
  //false if editing existing row
  handleButtonEvent(evt: any){
    if(evt == "add"){
      this.editRow = false;
      this.formValid = false;
    }else if(evt == "edit"){
      this.formValid = true;
      this.editRow = true;
    }
  }


  validate(item){
    this.lambdaError = false;
    this.lambdaMessage = '';

    if(!this.editRow){
      for(let x=0; x < this.formatList.length; x++){
        if(this.formatList[x].Key == item.Key){
          this.lambdaError = true;
          this.lambdaMessage = "Duplicate format name not permitted.";
          return false;
        }
      }
      if(item.Key.length < 3){
        this.lambdaError = true;
        this.lambdaMessage = "Format Name is too short.";
        return false;
      }
    }

    if(item.data.matchPattern.length == 0 || item.data.formatPattern.length == 0){
      this.lambdaError = true;
      this.lambdaMessage = "Pattern fields cannot be blank";
      return false;
    }

    return true;
  }
}
